import { useConfig } from "../../../contexts/ConfigContext"
import { useSale } from "../../../contexts/SaleContext"
import React, { useEffect, useState } from "react"
import { Dropdown, Popconfirm, TableColumnsType } from "antd"
import { mutate } from "swr"
import { contentLayout, contentPath, modules, saleStatus } from "../../../config/const"
import TableView from "../TableView"
import { useCompany } from "../../../contexts/CompanyContext"
import useAuth from "../../../hooks/useAuth"
import { useSales } from "../../../hooks/useSale"
import { MoreOutlined } from "@ant-design/icons"
import { textNumberFormater } from "../../../utils"
import { useHistory } from "react-router-dom"
import { useSecureRequest } from "../../../hooks/useSecureRequest"

function ViewPendingSale(){
  const history = useHistory()
  const { config,updateConfig } = useConfig()
  const { sale, updateSale} = useSale()
  const {company} = useCompany()
  const [spinning, setSpinning] = useState(false)
  const [skeleton, setSkeleton] = useState(true)
  const { securePost } = useSecureRequest()
  const {tokenData} = useAuth.useToken('authCsrfToken',config.session,config.key)
  const {data:saleData} = useSales(tokenData,{
    company:company.current.uid,
    status:saleStatus.PENDING,
    documentType: "SALE_INVOICE",
    pending: true,
    module: config.module
  },company.current.id)
  useEffect(()=>{
    if(tokenData && saleData?.movementList){
      updateSale({pendingList:saleData.movementList})
      setSkeleton(false)
    }

  },[tokenData,saleData])

  let title = 'Ventas pendientes por facturar'
  let emptyMessage = 'Aun no hay registros pendientes por facturar'
  
  const handleClick = async (data:any) => {
    console.log("Click sobre item: ",data)
    setSpinning(true)
    const saleResponse = await securePost('/inventory/movement/get-movement',{
      company: company.current.uid,
      uidMovement: data.uid,
      module: config.module
    })
    setSpinning(false)
    if(saleResponse.status === 200){
      updateSale({item_list: saleResponse.movement.item_list,currentPending:saleResponse.movement})
      updateConfig({forceModule:true,module:modules.RegisterSale,content:contentLayout[modules.RegisterSale]})
      history.push(contentPath[modules.RegisterSale])
    }else{
      alert("Ha ocurrido un error, por favor recargue la página e intente de nuevo")
    }
  }

  const menuItems = (record:any) => [
    {
      key: "1",
      label: (<button className="link-button" onClick={() => handleClick(record)}>Retomar venta</button>),
    },
    {
      key: "2",
      label: (
        <Popconfirm title="¡Esta seguro que desea eliminar este elemento?" onConfirm={() => deleteItem(record.uid)}>
          <span>Eliminar</span>
        </Popconfirm>
      ),
    },
  ];
  //Solo debe existir en firestore al ser un PENDING
  //Por lo tanto la actualización solo aplica en Firestore
  async function deleteItem(uid:string){
    setSpinning(true)
    const companyUid = company.current.uid
    if(companyUid && uid){
      const newPendinglist = sale.pendingList.filter(val => val.uid !== uid)
      await securePost("/sale/index/update-sale",{
        company:companyUid,
        uidSale:uid,
        sale:{
          status: saleStatus.CANCELLED
        },
        module: config.module
      })
      updateSale({pendingList:newPendinglist})
      if(sale.currentPending?.uid === uid){
        updateSale({currentPending:null, item_list: []})
      }
      mutate(
        key => Array.isArray(key) && typeof key[0] === 'string' && key[0].includes('/inventory/movement'),
        undefined,
        { revalidate: true }
      )
    }
    setSpinning(false)
  }
  const rowMenu = (record:any) => {
    if(typeof record.key === "string"){
      return(<></>)
    }else{
      return(
        <Dropdown menu={{items:menuItems(record)}} trigger={['click']}>
          <button className="link-button" style={{ display: "block",width:"100%", justifyContent: "center",cursor:"pointer" }} onClick={(e) => e.stopPropagation()}>
            <MoreOutlined
              style={{ fontSize: "18px", cursor: "pointer" }}
            />
          </button>
        </Dropdown>
      )
    }
  }

  const tableColumns:TableColumnsType = [
    {title: "#",dataIndex:"register"},
    {title: "Registro",dataIndex:"document_number"},
    {title: "Items",dataIndex:"items"},
    {title: "Ultima modificación",dataIndex:"updated_at",render:(text)=>new Date(text).toLocaleString()},
    {title: "Total",dataIndex:"total_amount",render:(text)=><label className="numeric-values-data-table">{textNumberFormater(text)}</label>},
    {title:"Acciones",key:"actions",render:(_, record) => rowMenu(record)}
  ]

  const dataTable = sale.pendingList.map((el:any,i:number)=>{
      el.register = i + 1
      el.key = i  
      return el
    })
  
  return (
    <TableView
      title={title}
      spinning={spinning}
      skeleton={skeleton}
      tableColumns={tableColumns}
      dataTable={dataTable}
      onRow={() => {}}
      emptyMessage={emptyMessage}>
    </TableView>
  )
}

export default ViewPendingSale